const firebaseConfig = {
  apiKey: "AIzaSyBKDYjyvsePCWxjIj6Egexb6YN4KBPYY9M",
  authDomain: "healtcare-react.firebaseapp.com",
  projectId: "healtcare-react",
  storageBucket: "healtcare-react.appspot.com",
  messagingSenderId: "473163551480",
  appId: "1:473163551480:web:d6a7b912a57615b503610d",
};
export default firebaseConfig;
